var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "errorContainer",
    { attrs: { error: _vm.error, warning: _vm.warning } },
    [
      _c("b-col", { attrs: { md: "12" } }, [
        _c(
          "h1",
          {
            class: [
              `${!_vm.$screen.sm ? "main-page-title" : ""}`,
              ,
              { "is-pwa": _vm.$isPwa() },
            ],
          },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.FormMSG(1, "Supplier Label List")) +
                "\n\t\t"
            ),
          ]
        ),
      ]),
      _c(
        "transition",
        { attrs: { name: "slide" } },
        [
          _c(
            "b-card",
            { attrs: { "no-body": "" } },
            [
              _c(
                "b-card-body",
                [
                  _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "my-1", attrs: { cols: "9" } },
                        [
                          _vm.$screen.width >= 992
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    label: _vm.FormMSG(2, "Filter"),
                                    "label-cols": "2",
                                    "label-align-sm": "left",
                                    "label-size": "sm",
                                    "label-for": "filterInput",
                                  },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    { attrs: { size: "sm" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "search",
                                          id: "filterInput",
                                          placeholder: _vm.FormMSG(
                                            3,
                                            "Type to search..."
                                          ),
                                          autocomplete: "off",
                                        },
                                        model: {
                                          value: _vm.filter,
                                          callback: function ($$v) {
                                            _vm.filter = $$v
                                          },
                                          expression: "filter",
                                        },
                                      }),
                                      _c(
                                        "b-input-group-append",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { disabled: !_vm.filter },
                                              on: {
                                                click: function ($event) {
                                                  _vm.filter = ""
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-times",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { cols: "3" } }, [
                        _c(
                          "div",
                          { staticClass: "float-right" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass:
                                  "btn btn-primary btn-md float-right",
                                attrs: {
                                  block: !_vm.$screen.md,
                                  variant: "success",
                                  size: "md",
                                },
                                on: { click: _vm.newLabel },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.FormMSG(4, "New Label")) +
                                    "\n\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", xl: "12" } },
                        [
                          _c("b-table", {
                            ref: "filmCommissionTable",
                            attrs: {
                              responsive: "sm",
                              "selected-variant": _vm.selectedColor,
                              hover: _vm.hover,
                              "select-mode": _vm.selectMode,
                              items: _vm.contacts,
                              fields: _vm.fields,
                              "head-variant": _vm.hv,
                              "empty-text": _vm.FormMSG(
                                5,
                                "No supplier label found"
                              ),
                              "current-page": _vm.currentPage,
                              filter: _vm.filter,
                              "per-page": _vm.perPage,
                              "tbody-tr-class": "p-0",
                              selectable: "",
                              bordered: "",
                              small: "",
                              "show-empty": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(edit)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center",
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticStyle: {
                                              "line-height": "16px",
                                            },
                                            attrs: {
                                              variant: "none",
                                              size: "sm",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editSupplier(
                                                  data.item.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              _vm.getLucideIcon(
                                                _vm.ICONS.EDIT.name
                                              ),
                                              {
                                                tag: "component",
                                                attrs: {
                                                  color: _vm.ICONS.EDIT.color,
                                                  size: 20,
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(delete)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center",
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticStyle: {
                                              "line-height": "16px",
                                            },
                                            attrs: {
                                              variant: "none",
                                              size: "sm",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteSupplier(
                                                  data.item.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              _vm.getLucideIcon(
                                                _vm.ICONS.TRASH.name
                                              ),
                                              {
                                                tag: "component",
                                                attrs: {
                                                  color: _vm.ICONS.TRASH.color,
                                                  size: 20,
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }